<template>
    <div>
        <div class='footer-column-title'>
            SERVICES
        </div>
        <div class='footer-column-links'>
            <div @click="onClickLink('delivery')"><a class="footer-link">Delivery</a></div>
            <div @click="onClickLink('drink-responsibly')"><a class="footer-link">Drink Responsibly</a></div>
            <div @click="onClickLink('privacy-cookies')"><a class="footer-link">Privacy &amp; Cookies</a></div>
            <div @click="onClickLink('faqs')"><a class="footer-link">FAQs</a></div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onClickLink(page) {
            this.$router.push(`/${page}`);
        }
    }
}
</script>
